import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportToCSV = (data, filename = 'visitor-report') => {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${filename}-${new Date().toISOString().slice(0, 10)}.csv`);
};

export const exportToPDF = (data, filename = 'visitor-report') => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  doc.setFontSize(16);
  doc.setTextColor(33, 37, 41);
  doc.text('Visitor Entry Report', 14, 15);
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Generated on: ${new Date().toLocaleString('en-IN')}`, 14, 22);
  doc.text(`Total Records: ${data.length}`, 14, 28);

  if (data.length === 0) {
    doc.text('No records found.', 14, 40);
    saveAs(doc.output('blob'), `${filename}.pdf`);
    return;
  }

  const columns = Object.keys(data[0]);
  const rows = data.map((row) => columns.map((col) => row[col] ?? ''));

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 32,
    styles: { fontSize: 7, cellPadding: 2 },
    headStyles: { fillColor: [13, 110, 253], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 249, 250] },
    margin: { top: 32, left: 14, right: 14 },
  });

  doc.save(`${filename}-${new Date().toISOString().slice(0, 10)}.pdf`);
};
